import { useContext, useMemo } from 'react'
import ImageKit from 'imagekit-javascript'
import { UserContext } from '../providers'

export const XHRwithCustomDomain = (domain: string) => {
  const xhr = new XMLHttpRequest()
  const originalOpen = xhr.open

  xhr.open = function (
    method: string,
    url: string | URL,
    async?: boolean,
    username?: string | null,
    password?: string | null,
  ) {
    const urlString = url.toString()
    const modifiedUrl = urlString.replace('https://upload.imagekit.io', domain)
    return originalOpen.call(
      this,
      method,
      modifiedUrl,
      async ?? true,
      username,
      password,
    )
  }

  return xhr
}

const useImageKitClient = (): ImageKit => {
  const { user } = useContext(UserContext)

  const imagekit = useMemo(() => {
    if (user) {
      return new ImageKit({
        urlEndpoint: user.baseUrlForClientImageFetch,
        publicKey: user.publicKey,
        authenticationEndpoint: `/api/clients/${user.clientNumber}/upload/signature/v2`,
        apiVersion: 'v2-alpha',
      })
    }

    return new ImageKit({ urlEndpoint: 'https://ik.imagekit.io/demo' })
  }, [user?.baseUrlForClientImageFetch])

  return imagekit
}

export default useImageKitClient
